import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { PersonMid, AngleUpSmall, AngleDownSmall } from '@zooplus/icons';
import { useTranslations } from '../../translations/index.js';
import Flyout from '../Flyout/Flyout.js';
import styles from './Account.module.css.js';
import { useBreakpointsMatching } from '../../node_modules/@zooplus/myaccount-utils/dist/es/hooks/useBreakpointsMatching/useBreakpointsMatching.js';
import { Anchor } from '../../node_modules/@zooplus/ui-components/dist/es/components/Anchor/Anchor.js';

const ACCOUNT_ID = 'srh-account';
const Account = ({ showFlyout, setShowFlyout }) => {
    const { t } = useTranslations();
    const breakpoint = useBreakpointsMatching();
    const timeoutId = useRef();
    const isAccessibleText = breakpoint.match('SMARTPHONE', 'PHABLET', 'TABLET');
    const onBlur = useCallback(() => {
        timeoutId.current = setTimeout(() => setShowFlyout(false));
    }, [setShowFlyout]);
    const onFocus = useCallback(() => {
        clearTimeout(timeoutId.current);
    }, []);
    const handleKeyUp = useCallback((event) => {
        if (event.key === 'Enter') {
            setShowFlyout((state) => !state);
        }
        else if (event.key === 'Escape') {
            setShowFlyout(false);
        }
    }, [setShowFlyout]);
    return (jsxs("div", { tabIndex: 0, id: ACCOUNT_ID, onKeyUp: handleKeyUp, onMouseEnter: () => setShowFlyout(true), onMouseLeave: () => setShowFlyout(false), onBlur: onBlur, onFocus: onFocus, "aria-label": t('menu.accessible.description'), "aria-describedby": "shopHeaderAccountFlyoutDescription", "aria-haspopup": true, "aria-expanded": showFlyout, "aria-controls": "shopHeaderAccountFlyout", className: styles.accountWrapper, children: [jsx("div", { id: "shopHeaderAccountFlyoutDescription", "aria-hidden": true, className: styles.accessibleText, children: t('flyout.accessible.description') }), jsxs(Anchor, { href: "/account/overview", isBold: true, children: [jsx("i", { "aria-hidden": true, className: `${isAccessibleText ? styles.primaryIcon : styles.primaryIconNoMargin} ${showFlyout ? styles.primaryIconWithFlyoutOpen : ''}`, children: jsx(PersonMid, {}) }), jsx("div", { id: "shopHeaderAccountLink", className: isAccessibleText ? styles.accessibleText : styles.linkText, children: t('account') }), jsx("i", { "aria-hidden": true, className: styles.inlinedPrimaryIcon, children: showFlyout ? jsx(AngleUpSmall, {}) : jsx(AngleDownSmall, {}) })] }), jsx(Flyout, { visible: showFlyout, id: "shopHeaderAccountFlyout", labelId: ACCOUNT_ID })] }));
};
Account.displayName = 'Account';

export { ACCOUNT_ID, Account as default };
//# sourceMappingURL=Account.js.map
